import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload.js'

const resourceName = 'gedcompartilhamento'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=nivel,menu,asc&size=500`, data, config)
const GetAllByMenu = (menuId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}&menuId=${menuId}&sort=criacaoData,asc`, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClientUpload.post(`${APICore}/${resourceName}/`, data, config)
const Share = (data = {}, config = {}) => APIClientUpload.post(`${APICore}/${resourceName}/share`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Search = (nome = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?name=${nome}&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

const GedCompartilhamentoRepository = {
  GetAll,
  GetAllPaging,
  GetAllByMenu,
  GetById,
  Create,
  Share,
  Update,
  Search,
  ChangeStatus,
  Delete
}

export default GedCompartilhamentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/ged/gedcompartilhamento.js